import React from "react"
import Link from "components/elements/Link"
import { Website } from "sharedTypes"

type Props = {
  website: Website
}

const WebsiteLink = ({ website: { previewUrl, url: publicUrl } }: Props) => {
  const url = previewUrl ?? publicUrl

  if (!url) {
    return null
  }

  return (
    <Link
      display="block"
      isExternal
      href={url}
      fontWeight="semibold"
    >
      {url}
    </Link>
  )
}

export default WebsiteLink
